export default __webpack_public_path__ + "static/media/deleteImg.577721e1.svg";